// extracted by mini-css-extract-plugin
export default {"root":"InteractiveClinicMap_root__rO1yK","canvas":"InteractiveClinicMap_canvas__LNdYn","overlay":"InteractiveClinicMap_overlay__7kegP","badge":"InteractiveClinicMap_badge__yEFmb"};